




import Vue from 'vue'
import { createNamespacedHelpers } from 'vuex'
import { IShippingMethod } from '@/models'
import { STORE_MODULES, ACTIONS_ORDER } from '@/enums'
import { BaseShippingMethodListItem } from '@/components'

const { mapActions } = createNamespacedHelpers(STORE_MODULES.ORDER)

export default Vue.extend({
    name: 'ShippingMethodListItem',

    components: { BaseShippingMethodListItem },

    model: {
        prop: 'isRequestInProgress',
        event: 'update:is-request-in-progress',
    },

    props: {
        method: {
            type: Object as () => IShippingMethod,
            required: true,
        },
        isRequestInProgress: {
            type: Boolean,
            required: true,
        },
    },

    data: () => ({
        isRequestInProgressInternal: false,
    }),

    watch: {
        isRequestInProgressInternal(isInProgress: boolean) {
            this.$emit('update:is-request-in-progress', isInProgress)
        },
    },

    methods: {
        ...mapActions({ createAndSetShipping: ACTIONS_ORDER.CREATE_AND_SET_SHIPPING }),

        async createShipping(): Promise<void> {
            this.isRequestInProgressInternal = true

            try {
                await this.createAndSetShipping(this.method)
            } catch (error) {}

            this.isRequestInProgressInternal = false
        },
    },
})
